import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RESTAURANT_CREATE,
  RESTAURANT_FILTER,
  RESTAURANT_FILTER_CUISINE_SUBMENU,
  RESTAURANT_FILTER_STATUS_SUBMENU,
  RESTAURANT_FILTER_TYPE_SUBMENU,
  RESTAURANT_VIEW,
} from '../../../../../constants/restaurantConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_RESTAURANT,
} from '../../../../../constants/RoleConsts';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  changeRestaurantStatus,
  createDataSortMapping,
  deleteRestaurantDetails,
} from '../../../../../utils/PropertyAPIUtils';
import {
  allRestaurantSelector,
  fetchAllRestaurant,
  setAllRestaurant,
} from '../../../../property/propertySlice';
import InfoListTable from './Info-List-Table';
import { checkAuthState } from '../../../../../utils/APIUtils';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import {
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../../utils/ServicesAPIUtils';
import {
  ResetFilterList,
  selectedCheckList,
  getCheckedIds,
  updateCheckedStatus,
} from '../../../../../utils/formUtils';
import { generateConfirmationMessage } from '../../../../../utils/formUtils';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const InfoList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    allRestaurantLoader,
    hotelId,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const allRestaurantList = useSelector(allRestaurantSelector);
  const dispatch = useDispatch();
  const [restaurantList, setRestaurantList] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const [filterDataList, setFilterDataList] = useState([]);
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const [popUp, setPopUp] = useState(false);
  const [tempSearchText, setTempSearchText] = useState('');
  const [isCulinaryOperationManager, setIsCulinaryOperationManager] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [actionName, setActionName] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const isFilterApplied = useRef(false);
  const [dragEnabled, setDragEnabled] = useState(true);
  const dragDisabled = !dragEnabled || restaurantList?.length <= 1;
  const prevHotelIdRef = useRef(hotelId);

  useEffect(() => {
    (async () => {
      const currUser = await checkAuthState();
      if (
        currUser &&
        currUser?.attributes &&
        currUser?.attributes['custom:role'] === 'CULINARY_OPERATIONS_MANAGER'
      ) {
        setIsCulinaryOperationManager(true);
      }
    })();
  }, []);

  useEffect(() => {
    setFilterDataList(RESTAURANT_FILTER);
  }, []);

  useEffect(() => {
    setTempSearchText('');
    resetFilterDataList();
    setFilteredBaseList(allRestaurantList);
    setRestaurantList((prevList) => {
      return allRestaurantList?.map((restaurant) => {
        const isChecked = selectedCheckList(prevList, restaurant.id);
        return {
          ...restaurant,
          isChecked,
        };
      });
    });
  }, [allRestaurantList]);

  const setSearchText = async (searchText) => {
    setTempSearchText(searchText);
    const checkedIdList = getCheckedIds(restaurantList, 'isChecked');
    const filteredRows = filteredBaseList.filter((item) =>
      item.name?.toLowerCase().includes(searchText.toLowerCase()),
    );
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setRestaurantList(updatedCheckedList);
  };

  const handleCellMenuClick = (event, restaurant) => {
    if (selectedRestaurantsLength > 1) {
      setShowBulkKebabSelectionAlert(true);
      return;
    } else {
      setSelectedValue({
        id: restaurant.id,
        name: '',
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        restaurant,
      });
    }
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      restaurant: null,
    });
  };

  const onOpenDrawer = (event, type) => {
    if (selectedRestaurantsLength) {
      setRestaurantList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.restaurant);
    handleClose();
  };

  const onViewDetails = (restaurant, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(RESTAURANT_VIEW, true, restaurant);
    }
  };

  const onClickView = (e) => {
    if (selectedValue && selectedValue.restaurant) {
      onViewToggle(RESTAURANT_VIEW, true, selectedValue.restaurant);
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onDeleteRestaurant = (event) => {
    event.preventDefault();
    setSelectedValue((prev) => ({
      ...prev,
      name: selectedValue.restaurant.name,
      title: 'Are you sure you want to delete',
      description:
        'This action cannot be reversed. Information associated with this restaurant will also be lost',
      status: true,
      anchorEl: null,
    }));
  };

  const onDelete = async () => {
    try {
      if (selectedValue && selectedValue?.id) {
        const lang = decryptLocalStorage('lang');
        const language = lang !== 'en' ? lang : '';
        await deleteRestaurantDetails(hotelId, selectedValue.id, language);
        resetFilterDataList();
        dispatch(fetchAllRestaurant(hotelId));
        notificationManager('success', 'Restaurant deleted successfully');
      }
      handleClose();
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Unable to delete Restaurant',
      );
      handleClose();
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = () => {
    handleClose();
  };

  const resetFilterDataList = () => {
    RESTAURANT_FILTER[1].subMenu = RESTAURANT_FILTER_CUISINE_SUBMENU;
    RESTAURANT_FILTER[2].subMenu = RESTAURANT_FILTER_TYPE_SUBMENU;
    RESTAURANT_FILTER[3].subMenu = RESTAURANT_FILTER_STATUS_SUBMENU;
    setFilterDataList(RESTAURANT_FILTER);
  };

  useEffect(() => {
    resetFilterDataList();
  }, []);

  useEffect(() => {
    if (allRestaurantLoader || restaurantList.length === 0) return;

    const totalItems = restaurantList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) onsetPage(maxPageIndex);
  }, [restaurantList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef.current !== hotelId) {
      onsetPage(0);
      resetFilterDataList();
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const filteredRecoard = (filters, field) => {
    if (field === 'all') {
      setFilteredBaseList(allRestaurantList);
      setRestaurantList(allRestaurantList);
      resetFilterDataList();
      isFilterApplied.current = false;
    } else {
      isFilterApplied.current = true;
      const filterIdWithFields = filterDataList
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((item) => item !== null);
      const filteredRecords = allRestaurantList?.filter((treatment) => {
        const doesFilterSatisfy = filterIdWithFields?.map((filter) => {
          if (
            filter.field === 'cuisine' &&
            treatment?.primaryCuisine &&
            treatment?.secondaryCuisine
          ) {
            const treatmentCuisineArray = [
              treatment?.primaryCuisine,
              ...treatment?.secondaryCuisine,
            ];
            const filterArray = filter.id.filter((ele) =>
              treatmentCuisineArray?.map((item) => item.toLowerCase())?.includes(ele.toLowerCase()),
            );
            return filterArray.length ? true : false;
          }

          if (filter.field === 'isActive') {
            const filterArray = filter.id.filter((ele) => {
              return (
                (ele === 'active' && treatment.isActive) ||
                (ele === 'inactive' && !treatment.isActive)
              );
            });
            return filterArray.length ? true : false;
          }

          return filter.id.includes(treatment[filter.field].toLowerCase());
        });
        return !doesFilterSatisfy.includes(false);
      });
      onsetPage(0);
      setRestaurantList(filteredRecords);
      setFilteredBaseList(filteredRecords);
    }
  };

  const onChangeStatus = async (e, payload) => {
    e.stopPropagation();
    resetFilterDataList();
    try {
      const item = { ...payload };
      item.isActive = !payload.isActive;
      await changeRestaurantStatus(hotelId, item.id, item.isActive);
      notificationManager(
        'success',
        item.isActive ? 'Restaurant activated successfully' : 'Restaurant deactivated successfully',
      );
      dispatch(fetchAllRestaurant(hotelId));
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed');
      }
    }
    handleClose(e);
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const listOfRestaurantIds = restaurantList
    ?.filter((item) => item?.isChecked)
    ?.map((item) => item?.id);

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Restaurant',
    listOfRestaurantIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const filterApplied = tempSearchText?.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'RESTAURANT';
      await updateSelectedItemsStatus(
        listOfRestaurantIds,
        hotelId,
        selectedLang,
        moduleName,
        '',
        isActive,
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllRestaurant(hotelId));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the Restaurant was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const filterApplied = tempSearchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'RESTAURANT';
      await deleteSelectedItems(
        listOfRestaurantIds,
        hotelId,
        selectedLang,
        moduleName,
        '',
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllRestaurant(hotelId));
      notificationManager('success', 'Restaurants deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Restaurants',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const isFullAccess =
    permissions[RBAC_TYPE_HOTEL_RESTAURANT] === RBAC_PERMISSION_LEVEL_FULL_ACCESS;

  const shouldShowFilter =
    isFullAccess && !(isCulinaryOperationManager && restaurantList.length === 1);

  const handleAction = (actionName) => {
    let selectedValue = restaurantList?.filter((restaurant) => restaurant?.isChecked);

    switch (actionName) {
      case 'Delete':
        if (selectedValue?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const selectedRestaurantsLength = restaurantList?.filter(
    (restaurant) => restaurant?.isChecked,
  ).length;

  return (
    <div className='mt-4 mb-4 group-list-container'>
      <SearchBar
        type={RESTAURANT_CREATE}
        buttonName='Add Restaurant'
        setSearchText={setSearchText}
        onOpenDrawer={onOpenDrawer}
        displayAddOrEdit={shouldShowFilter ? 'show' : 'hide'}
        filterList={shouldShowFilter ? filterDataList : []}
        setFilterDataList={setFilterDataList}
        filteredRecoard={filteredRecoard}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={restaurantList}
        setPlaceHolder={setRestaurantList}
        globalPlaceHolder={allRestaurantList}
        setGlobalPlaceHolder={setAllRestaurant}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='Restaurants info'
        module='RESTAURANT'
        searchText={tempSearchText}
        setSearch={setTempSearchText}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
        setDrag={setDragEnabled}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {allRestaurantLoader && (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        )}
        <InfoListTable
          page={page}
          rowsPerPage={rowsPerPage}
          onOpenDrawer={onOpenDrawer}
          onViewDetails={onViewDetails}
          selectedValue={selectedValue}
          handleClose={handleClose}
          onClickView={onClickView}
          permissions={permissions}
          handleCellMenuClick={handleCellMenuClick}
          restaurantList={restaurantList}
          setRestaurantList={setRestaurantList}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onDeleteRestaurant={onDeleteRestaurant}
          onChangeStatus={onChangeStatus}
          setVisible={setVisible}
          isCulinaryOperationManager={isCulinaryOperationManager}
          searchText={tempSearchText}
          setActionMenuList={setActionMenuList}
          isAllSelected={isAllSelected}
          setIsAllSelected={setIsAllSelected}
          selectedRestaurantsLength={selectedRestaurantsLength}
          tempSearchText={tempSearchText}
          setTempSearchText={setTempSearchText}
          dragDisabled={dragDisabled}
        />
      </div>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDelete}
          onDeleteCancel={onDeleteCancel}
        />
      )}

      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedRestaurantsLength} ${
            selectedRestaurantsLength > 1 ? 'restaurants' : 'restaurant'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelection();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}

      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedRestaurantsLength}  ${
            selectedRestaurantsLength > 1 ? 'restaurants' : 'restaurant'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
      {showBulkKebabSelectionAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkKebabSelectionAlert}
          onClose={() => setShowBulkKebabSelectionAlert(false)}
          message='Please select one item from the list that you want to edit.'
          centerButtonName='OK'
        />
      )}
    </div>
  );
};

export default InfoList;
